import styled, { css } from 'styled-components';
import { theme } from '../../../../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 4px;
  row-gap: 6px;
`;

export const EditableLabel = styled.div<{ $isActionsVisible: boolean }>`
  display: flex;
  align-items: center;
  border-radius: 4px;
  column-gap: 4px;

  &:hover {
    cursor: pointer;
  }

  padding-left: 16px;
  padding-right: 16px;
  flex-wrap: wrap;

  ${({ $isActionsVisible }) =>
    $isActionsVisible &&
    css`
      padding-right: 0;
    `}
`;

export const Bracket = styled.div`
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: ${theme.colors.mainBlue};
`;

export const Condition = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

export const ActionContainer = styled.div`
  width: 12px;
  height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 4px;
`;

export const LogicOp = styled.div`
  flex: 0 0 auto;
  margin-right: 4px;
  margin-left: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
`;

export const LogicOpWrapper = styled.div`
  margin: 0 16px;
`;

export const PredicateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;
